<!-- <div class="business-list-view col-md-12"> -->

      <!-- Wireframe header (.section-hd + .panel-search). The search is live: the
           list below already filters on searchText (customFilter), so no Search
           button. Old header in #legacyHeader. -->
      <div class="gs-biz-list-hd" *ngIf="useWireframeHeader; else legacyHeader">
        <div class="gs-biz-list-row">
          <div class="gs-biz-list-title">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            Communities
            <span class="gs-biz-list-count">({{communityList?.length || 0}})</span>
          </div>
          <!-- Still disabled, as before (no create flow wired from here yet). -->
          <div class="gs-biz-list-actions" *ngIf="businessUrlData?.isSuperAdmin === 'true'">
            <button type="button" class="gs-biz-list-btn gs-biz-list-btn--primary" disabled #createcommunity>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>Create Community
            </button>
          </div>
        </div>
        <div class="gs-biz-list-search">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input type="text" name="searchtxt" placeholder="Search communities…" aria-label="Search communities" [(ngModel)]="searchText">
          <button *ngIf="searchText" type="button" class="gs-biz-list-clear" aria-label="Clear search" (click)="searchText = ''">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
      </div>

      <ng-template #legacyHeader>
      <div class="hpanel">
        <div class="panel-body border-radius-top-left-right-6 business-community-header-container">
          <div class="business-community-name">
            <!-- <label class=" control-label font-bold">{{businessData.businessName | uppercase}}</label> -->

            <ng-container *ngIf="createCommunity != 'SUPERADMIN'">
              <label class=" control-label">{{businessData.businessName | truncate :
                18 }}</label>
            </ng-container>

            <div *ngIf="businessUrlData?.isSuperAdmin ==='true'">
              <!-- <a  (click)="routePage()" disabled
                class="btn btn-primary primary-btn" style="margin-top: 5px; margin-bottom: 5px;"
                #createcommunity>Create Community aa</a> -->
                <a  disabled
                class="btn btn-primary primary-btn" style="margin-top: 5px; margin-bottom: 5px;"
                #createcommunity>Create Community</a>
            </div>

            <div *ngIf="communityList.length >=1">
              {{communityList.length}} Community
            </div>
          </div>
          <div class="business-community-search-bar" >
            <input type="text" name="searchtxt" id="searchtxt" [(ngModel)]="searchText" placeholder="Search Communities" disabled
              class="form-control input-sm">
          </div>
          <div class="business-community-search-btn">
            <button type="submit" class="btn primary-btn"
              (click)="searchCommunity()"disabled>Search</button>
          </div>
        </div>
      </div>
      </ng-template>


  <div>
    <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0" *ngFor="let data of communityList | customFilter :{communityName:searchText}:false"
      >
      <app-community-card [data]="data"></app-community-card>

      <!-- <div class="hpanel {{data.comColor}} contact-panel">
        <div class="panel-body" style="padding: 10px;">
          <div class="pull-right m-t-m-15">
          </div>
          <img alt="logo" class="img-circle" [src]="data.logo ? photoUrl+data.logo : 'assets/icon/comm.png'">
          <h5 class="com-ellipse"><a (click)="redirectCommunity(data)" data-toggle="tooltip" data-placement="top"
              title="{{ data.communityName}}">{{data.communityName}}</a></h5>
          <div class="text-muted font-bold m-b-xs">{{data.communityType ? 'PRIVATE' : 'PUBLIC'}}</div>
        </div>
        <div class="panel-footer contact-footer" style="padding: 0;">
          <div class="row">
            <div class="col-md-6 border-right">
              <div class="contact-stat"><span>Members: </span>
                <strong>{{data['memberCnt']}}</strong>
              </div>
            </div>
            <div class="col-md-6">
              <div class="contact-stat"><span>Posts: </span>
                <strong>{{data['postCnt']}}</strong>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>


    <div class="aa" *ngIf="communityList?.length ==0">
         <p >Please upgrade your profile to premium profile to create communities.
        </p>
    </div>

  </div>
<!-- </div> -->
